import styled from "styled-components";
import { Tag } from "antd";

export const StatusTag = styled(Tag)`
  padding: 4px 16px;
  border-radius: 4px;
`;
